import type React from 'react';

import { cn } from '@change/ds-utils';

type TaskCheckboxProps = Readonly<{
	name: string;
	isSelected: boolean;
	isReadOnly?: boolean;
	onChange?: (isSelected: boolean) => void;
	ariaLabel?: string;
}>;

export const TaskCheckbox: React.FC<TaskCheckboxProps> = ({ name, isSelected, isReadOnly, onChange, ariaLabel }) => {
	const handleChange = () => {
		if (isReadOnly) return;
		onChange?.(!isSelected);
	};

	const handleKeyDown = (e: React.KeyboardEvent) => {
		if (e.key === ' ' || e.key === 'Enter') {
			e.preventDefault();
			handleChange();
		}
	};

	return (
		<label className={cn('group relative flex cursor-pointer items-center', isReadOnly && 'cursor-default')}>
			<input
				type="checkbox"
				name={name}
				checked={isSelected}
				readOnly={isReadOnly}
				onChange={handleChange}
				aria-label={ariaLabel}
				className="peer sr-only"
			/>
			<div
				role="presentation"
				onKeyDown={handleKeyDown}
				className={cn(
					'relative flex h-6 w-6 shrink-0 items-center justify-center rounded-[4px]',
					'border-stroke-weak border',
					'peer-focus-visible:outline-stroke-selected peer-focus-visible:outline peer-focus-visible:outline-2 peer-focus-visible:outline-offset-2',
					'bg-fill-inverse-strong',
					isSelected && 'bg-fill-selected border-transparent',
					!isReadOnly && 'group-hover:opacity-90 group-active:opacity-80',
				)}
			>
				{isSelected && (
					<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path
							className="fill-white"
							d="M5.13046 9.26041L2.69796 6.82791L1.86963 7.65041L5.13046 10.9112L12.1305 3.91124L11.308 3.08875L5.13046 9.26041Z"
						/>
					</svg>
				)}
			</div>
		</label>
	);
};
